// Supported report alarm type capability flags.
export const iREPORT_ALARM_CAPABILITY_NONE = 0x00
// Report alarms types.
export const REPORT_ALARM_CAPABILITY_ACDSTATE = 0x01 // ACD state duration thresholds.
export const REPORT_ALARM_CAPABILITY_CALLSTATE = 0x02 // Call alert & talk time thresholds.
export const REPORT_ALARM_CAPABILITY_CALLSTATE_TALKTIME_HIDE = 0x04 // Flag that specifically hides the "call talk time" alarm setting.
export const REPORT_ALARM_CAPABILITY_LOSTCALL = 0x08 // Alarm on a new abandoned call.
export const REPORT_ALARM_CAPABILITY_MASK_FORREPORTONLYFLAGS = 0xffffff // Bit mask used for viewing only report wide alarm capabilities
